import { render, staticRenderFns } from "./user-quiz.vue?vue&type=template&id=160379ba&scoped=true&"
import script from "./user-quiz.vue?vue&type=script&lang=js&"
export * from "./user-quiz.vue?vue&type=script&lang=js&"
import style0 from "./user-quiz.vue?vue&type=style&index=0&lang=css&"
import style1 from "./user-quiz.vue?vue&type=style&index=1&id=160379ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160379ba",
  null
  
)

export default component.exports